import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicFieldDropdown, BasicFieldCheckbox } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function PersonEditTemplate({ editView }) {
    const {
        contentLoading,
        form,
        userStore
    } = editView;

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('firstName')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('lastName')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('initials')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('userId')} store={userStore}/>
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('email')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('position')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('phone')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('extension')} />
                                </div>
                                <div className={`form__group col col-lrg-12`}>
                                    <BasicFieldCheckbox className="has-fake-label"  field={form.$('isActive')}/><span className="fake-label">Is Active</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

PersonEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PersonEditTemplate);
